export var ProtocolMode;
(function (ProtocolMode) {
    ProtocolMode["REQUIRED"] = "required";
    ProtocolMode["OPTIONAL"] = "optional";
    ProtocolMode["FORBIDDEN"] = "forbidden";
})(ProtocolMode || (ProtocolMode = {}));
const PROTOCOL_PART = '((https?|ftp):\\/\\/)';
const URL_PART_STRICT = '(([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}' + // domain name
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query part (no spaces or quotes by character class)
    '(\\#[-a-z\\d_]*)?$'; // anchor part
const URL_PART_NON_STRICT = '(([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}' + // domain name;
    '([/?][^\\s"]*)?$'; // non-strict path, query and anchor parts (no spaces or quotes)
const getUrlPattern = (strict) => (strict ? URL_PART_STRICT : URL_PART_NON_STRICT);
const getPattern = (protocolMode, strict) => {
    switch (protocolMode) {
        case ProtocolMode.REQUIRED:
            return `^${PROTOCOL_PART}${getUrlPattern(strict)}`;
        case ProtocolMode.FORBIDDEN:
            return `^${getUrlPattern(strict)}`;
        case ProtocolMode.OPTIONAL:
        default:
            return `^${PROTOCOL_PART}?${getUrlPattern(strict)}`;
    }
};
export const isUrlValid = (url, { protocolMode = ProtocolMode.OPTIONAL, strict = true } = {}) => {
    const pattern = getPattern(protocolMode, strict);
    const regExp = new RegExp(pattern, 'i');
    return regExp.test(url);
};
